export default __webpack_public_path__ + "static/media/water.56575f7c.svg";